import {
  type CohortBuilderDefinitionLegacy,
  CohortBuilderItemChangedBy,
  CohortBuilderItemChangeStatusLegacy,
  type IndexDateVariableLegacy,
} from '@verantos-dev/types-cohorts';

import { computeDiffForCohortBuilderItem } from '../computeDiffForCohortBuilderItem';

export const getFullCohortDslForIndexDate = (
  currentCohortDefinition: CohortBuilderDefinitionLegacy | undefined,
  nextIndexDate: IndexDateVariableLegacy,
  addChangeStatus = false
) => {
  const previousIndexDate = currentCohortDefinition?.indexDate;

  let _changeStatus: CohortBuilderItemChangeStatusLegacy | undefined;
  if (addChangeStatus && previousIndexDate) {
    // if index date previously existed
    if (computeDiffForCohortBuilderItem(previousIndexDate, nextIndexDate)) {
      // if index date previously existed and is different from current update
      if (previousIndexDate.changeStatus === CohortBuilderItemChangeStatusLegacy.NEW) {
        // if index date was new, then it's still new
        _changeStatus = CohortBuilderItemChangeStatusLegacy.NEW;
      } else {
        // index date is edited
        _changeStatus = CohortBuilderItemChangeStatusLegacy.EDITED;
      }
    } else {
      // if index date previously existed and is the same as current update, then it's unchanged
      _changeStatus = previousIndexDate.changeStatus;
    }
  } else if (addChangeStatus) {
    // if no index date previously existed, then it's new
    _changeStatus = CohortBuilderItemChangeStatusLegacy.NEW;
  }

  const indexDate: IndexDateVariableLegacy | undefined = nextIndexDate
    ? addChangeStatus
      ? {
          ...nextIndexDate,
          changeStatus: _changeStatus,
          changedBy: CohortBuilderItemChangedBy.COHORT_BUILDER,
        }
      : nextIndexDate
    : undefined;

  const cohortDefinition: CohortBuilderDefinitionLegacy = {
    studyPeriodRestrictions: currentCohortDefinition?.studyPeriodRestrictions,
    subjectVariables: currentCohortDefinition?.subjectVariables ?? [],
    indexDate,
    simpleEvents: currentCohortDefinition?.simpleEvents ?? [],
    derivedEvents: currentCohortDefinition?.derivedEvents ?? [],
    // FEATURE FLAG: Preserve analytical variables fields when present
    // These fields come from backend when analytical_variables_in_cohort_builder is enabled
    // CLEANUP TODO: When removing the `analytical_variables_in_cohort_builder` feature flag, ensure these fields are always preserved
    analyticalVariables: currentCohortDefinition?.analyticalVariables,
    criteria: currentCohortDefinition?.criteria,
  };

  return {
    cohortDefinition,
  };
};

export const getFullCohortDslForDeleteIndexDate = (
  currentCohortDefinition?: CohortBuilderDefinitionLegacy
) => {
  const cohortDefinition: CohortBuilderDefinitionLegacy = {
    studyPeriodRestrictions: currentCohortDefinition?.studyPeriodRestrictions,
    indexDate: undefined,
    subjectVariables: currentCohortDefinition?.subjectVariables ?? [],
    simpleEvents: currentCohortDefinition?.simpleEvents ?? [],
    derivedEvents: currentCohortDefinition?.derivedEvents ?? [],
    // FEATURE FLAG: Preserve analytical variables fields when present
    // These fields come from backend when analytical_variables_in_cohort_builder is enabled
    // CLEANUP TODO: When removing the `analytical_variables_in_cohort_builder` feature flag, ensure these fields are always preserved
    analyticalVariables: currentCohortDefinition?.analyticalVariables,
    criteria: currentCohortDefinition?.criteria?.filter(
      (c) => !('criteriaType' in c && c.criteriaType === 'index_date')
    ),
  };

  return {
    cohortDefinition,
  };
};
